var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-top-nav"}},[_c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"nav-logo"},[_c('inline-svg',{attrs:{"src":require('../../assets/logo.svg')}})],1)]),(_vm.user)?_c('div',[_c('user-nav-bar')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }